import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./ar.json";
import en from "./en.json";

export type Locale = "ar" | "en";
const KEY = "codvero.locale";

export function readLocale(): Locale {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "ar" || v === "en") return v;
  } catch {
    /* ignore */
  }
  return navigator.language.toLowerCase().startsWith("en") ? "en" : "ar";
}

export function applyLocale(l: Locale) {
  document.documentElement.lang = l;
  document.documentElement.dir = l === "ar" ? "rtl" : "ltr";
  try {
    localStorage.setItem(KEY, l);
  } catch {
    /* ignore */
  }
  void i18n.changeLanguage(l);
}

void i18n.use(initReactI18next).init({
  resources: { ar: { translation: ar }, en: { translation: en } },
  lng: readLocale(),
  fallbackLng: "ar",
  interpolation: { escapeValue: false },
});

export default i18n;
